import { createSelector } from 'reselect';
import { StoreState } from 'store/types';
import { TaxRatesState } from './types';

const selectTaxRates = (app: StoreState): TaxRatesState => app.taxRates;

export const getTaxRatesLoading = createSelector(
  selectTaxRates,
  (taxRates: TaxRatesState): TaxRatesState['loading'] => taxRates.loading
);

export const getTaxRatesError = createSelector(
  selectTaxRates,
  (taxRates: TaxRatesState): TaxRatesState['error'] => taxRates.error
);

export const getTaxRatesGettingTaxes = createSelector(
  selectTaxRates,
  (taxRates: TaxRatesState): TaxRatesState['gettingTaxes'] =>
    taxRates.gettingTaxes
);

export const getTaxRateTemplates = createSelector(
  selectTaxRates,
  (taxRates: TaxRatesState): TaxRatesState['taxRateTemplates'] =>
    taxRates.taxRateTemplates
);

export const getTaxRatesByCountry = createSelector(
  selectTaxRates,
  (taxRates: TaxRatesState): TaxRatesState['taxRatesByCountry'] =>
    taxRates.taxRatesByCountry
);

export const getTaxRatesForConnection = (connectionId?: string | null) =>
  createSelector(selectTaxRates, (taxRates: TaxRatesState) => {
    if (!connectionId) return [];
    return taxRates.byConnectionId[connectionId] || [];
  });

export const getTaxRateNameUpdateFailureTaxType = createSelector(
  selectTaxRates,
  (taxRates: TaxRatesState): TaxRatesState['taxRateNameUpdateFailureTaxType'] =>
    taxRates.taxRateNameUpdateFailureTaxType
);

